import * as React from "react";
import styled from "styled-components";
import { Trans } from "@lingui/macro";
import { DisplaySmall, Thirds, Center, color } from "@conserveit/blocks";
import { options } from "./ActionBar";

const Subdued = styled.span`
  color: ${color.theme.typography.subdued};
`;

interface Props {
  active: number;
  old: number;
  showClosed: boolean;
  closedOnStartDate?: number;
}

const InfoText: React.FC<Props> = ({
  active,
  old,
  showClosed,
  closedOnStartDate,
}) => {
  const getClosedOnStartDateLabel = React.useCallback(
    (showClosed: boolean, closedOnStartDate?: number) => {
      if (!showClosed || closedOnStartDate === undefined) return null;

      return options.find((option) => option.value === closedOnStartDate)!
        .label;
    },
    [active, old, showClosed, closedOnStartDate]
  );

  return (
    <Thirds>
      <Center>
        <DisplaySmall>
          <strong>
            {active}{" "}
            {showClosed ? (
              <Trans id="actions.closed">closed</Trans>
            ) : (
              <Trans id="actions.active">active</Trans>
            )}
          </strong>
          ,&nbsp;
          <Trans id="actions.days_old">
            <strong>{old} older than 60 days</strong>
          </Trans>{" "}
          {showClosed && closedOnStartDate !== undefined && (
            <Subdued>
              ({getClosedOnStartDateLabel(showClosed, closedOnStartDate)})
            </Subdued>
          )}
        </DisplaySmall>
      </Center>
    </Thirds>
  );
};

export default InfoText;
